module.exports = __webpack_public_path__ + "img/Weapon_116.6de679f5.png";